import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { NgClass } from "@angular/common";

@Component({
    selector: "rask-pillbox",
    templateUrl: "./pillbox.component.html",
    styleUrls: ["./pillbox.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgClass]
})
export class PillboxComponent {
    @Input() text: string;

    @Input() theme: string;

    @Input() contentClass: string;
}
